import { Vector2 } from "three";
import { Scene as Canvas2dutilScene } from "../utils";
import { Obj } from "../internal";
/* import { CubeMapStream, GeoFrame, PanoStream } from "../ennetwork/internal"; */
import { USERINPUTTYPE } from "../userinput/internal";
import { ImageObservation, STREAMTYPE } from "./internal";
import { PanoGeoFrameCollection } from "../geoframe/panogeoframecollection";
import { CubemapGeoFrameCollection } from "../geoframe/cubemapgeoframecollection";
/**
 * Container for all imageobservation data
 * @class ExternalMeasureScene
 * @author Benjamin Loesch
 * @extends Obj
 * @constructor
 */
export class ExternalMeasureScene extends Obj {
    constructor(scene, imageObservation, mousePos, candidateGeoFrameInfos, successCbf, failedCbf) {
        super();
        /**
         * the div id
         * @type {string}
         */
        this.externalSceneDomElementId = "external_measurement_scene";
        //subscribe events
        this.mousemoveeventnr = -1;
        this.mouseupeventnr = -1;
        this.doubleclkeventnr = -1;
        this.geoframechangednmbr = -1;
        this.viewmodechangedeventnmbr = -1;
        this.mousewheeleventnmbr = -1;
        this.keydeleteeventnmbr = -1;
        this.keyctrleventnmbr = -1;
        this.panoroteventnr = -1;
        this.panozoomeventnr = -1;
        this.imageSelectorOnMouseOverCSS = {
            backgroundColor: "rgba(255,255,255,0.8)",
        };
        this.imageSelectorCSS = {
            height: "15px",
            width: "15px",
            backgroundColor: "rgba(255,255,255,0.3)",
            borderRadius: "50%",
            display: "inline-block",
            margin: "0 5px 0 5px",
            shadow: "0px 0px 10px grey",
            pointerEvents: "all",
        };
        this.imageSelectorActiveCSS = {
            backgroundColor: "rgba(255,255,255,0.7)",
        };
        this.extSceneWidth = 400;
        this.extSceneHeight = 400;
        this.extSceneMargin = 40;
        /**
         * the small white dots to change geoframe by click on it
         * @type {Array}
         */
        this.imageSelectionDivs = [];
        this.scene = scene;
        this.candidateGeoFrames = [];
        this.successCbf = successCbf;
        this.failedCbf = failedCbf;
        this.queryPointsByFrameId = {};
        for (let i = 0; i < candidateGeoFrameInfos.length; i++) {
            this.queryPointsByFrameId[this.getIdFromGeoFrame(candidateGeoFrameInfos[i]["geoframe"])] =
                candidateGeoFrameInfos[i]["querypoint"];
            this.candidateGeoFrames.push(candidateGeoFrameInfos[i]["geoframe"]);
        }
        this.externalSceneDomElement = document.createElement("div");
        this.externalSceneDomElement.id = this.externalSceneDomElementId;
        const pos = this._calcExtScenePos(mousePos);
        this.externalSceneDomElement.style.width = this.extSceneWidth + "px";
        this.externalSceneDomElement.style.height = this.extSceneHeight + "px";
        this.externalSceneDomElement.style.position = "absolute";
        this.externalSceneDomElement.style.top = pos[0] + "px";
        this.externalSceneDomElement.style.left = pos[1] + "px";
        this.externalSceneDomElement.style.boxShadow = "#2c2c2c 0px 0px 7px 5px";
        const infra3ddiv = this.scene.engine.getCanvas().parentElement;
        infra3ddiv.appendChild(this.externalSceneDomElement);
        // FIXME: after fixing createSubScene
        this.extScene = this.scene.createSubScene(this.externalSceneDomElementId);
        this.extScene.getCursorStyleHandler().setCursorStyle("crosshair");
        const actualGeoFrameCollection = this.scene.getCurrentGeoFrameCollection();
        let SecondStreamCls = PanoGeoFrameCollection;
        if (actualGeoFrameCollection.type == STREAMTYPE.CUBEMAP)
            SecondStreamCls = CubemapGeoFrameCollection;
        const secondCurrentGeoFrame = actualGeoFrameCollection.getCurrentGeoFrame().copy();
        secondCurrentGeoFrame.scene = this.extScene;
        const secondgeoframearray = [];
        for (const secondgeoframe of actualGeoFrameCollection.geoframearray) {
            const asecondgeoframe = secondgeoframe.copy();
            asecondgeoframe.scene = this.extScene;
            secondgeoframearray.push(asecondgeoframe);
        }
        const secondGeoFramecollection = new SecondStreamCls(this.extScene, secondCurrentGeoFrame, secondgeoframearray);
        secondGeoFramecollection.setParentGeoFrameCollection(secondCurrentGeoFrame, secondgeoframearray);
        const geoframewithextscene = imageObservation.geoframe.copy();
        geoframewithextscene.scene = this.extScene;
        //copy imageobservation
        if (actualGeoFrameCollection.type == STREAMTYPE.CUBEMAP) {
            this.imageObservation = new ImageObservation(geoframewithextscene, imageObservation.x, imageObservation.y, imageObservation.focallength, imageObservation.id, imageObservation.sensorid, imageObservation.faceorientation, imageObservation.faceindex);
        }
        else {
            this.imageObservation = new ImageObservation(geoframewithextscene, imageObservation.x, imageObservation.y, imageObservation.focallength, imageObservation.id, imageObservation.sensorid);
        }
        //copy geoframes
        for (let i = 0; i < this.candidateGeoFrames.length; i++) {
            const gfid = this.getIdFromGeoFrame(this.candidateGeoFrames[i]);
            const gfs = secondGeoFramecollection.geoframearray.filter((geoframe) => {
                return this.getIdFromGeoFrame(geoframe) == gfid;
            });
            this.candidateGeoFrames[i] = gfs[0];
        }
        this.addImageSelectionMenu();
        this.geoframechangednmbr = this.extScene.userInputHandler.subscribeEvent(USERINPUTTYPE.GEOFRAMECHANGED, this.geoframechanged, this);
        this._changeActiveGeoframe(this.getIdFromGeoFrame(this.candidateGeoFrames[0]));
        this._subscribeEvents();
        //check stream types and subscribe events
        const geoframecollection = this.activeGeoFrame.parentGeoFrameCollection;
        if (geoframecollection.type == STREAMTYPE.CALOTTE || geoframecollection.type == STREAMTYPE.CUBEMAP) {
            this.panoroteventnr = this.extScene.userInputHandler.subscribeEvent(USERINPUTTYPE.PANO_ROTATION, (lat, lon) => {
                this.updateEpipolarLines();
            }, this);
            this.panozoomeventnr = this.extScene.userInputHandler.subscribeEvent(USERINPUTTYPE.PANO_ZOOM, (lat, lon) => {
                this.updateEpipolarLines();
            }, this);
        }
        this.initScene2d();
    }
    _calcExtScenePos(point) {
        const mainSceneLowerRight = new Vector2(this.scene.engine.getCanvas().width, this.scene.engine.getCanvas().height);
        //check scene-placement above point
        const dhu = point.y;
        const dhl = mainSceneLowerRight.y - dhu;
        const abovePoint = dhu > dhl;
        //check scene-placement right from point
        const dwl = point.x;
        const dwr = mainSceneLowerRight.x - dwl;
        const leftFromPoint = dwl > dwr;
        let top = 0;
        let left = 0;
        //ext scene is above-left from point.
        if (abovePoint && leftFromPoint) {
            top = point.y - this.extSceneMargin - this.extSceneHeight;
            left = point.x - this.extSceneMargin - this.extSceneWidth;
        }
        //ext scene is above-right from point.
        if (abovePoint && !leftFromPoint) {
            top = point.y - this.extSceneMargin - this.extSceneHeight;
            left = point.x + this.extSceneMargin;
        }
        //ext scene is below-left from point.
        if (!abovePoint && leftFromPoint) {
            top = point.y + this.extSceneMargin;
            left = point.x - this.extSceneMargin - this.extSceneWidth;
        }
        //ext scene is below-right from point.
        if (!abovePoint && !leftFromPoint) {
            top = point.y + this.extSceneMargin;
            left = point.x + this.extSceneMargin;
        }
        return [top, left];
    }
    _subscribeEvents() {
        //subscribe events
        this.mousemoveeventnr = this.extScene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEMOVE, this._onMouseMove, this);
        this.mouseupeventnr = this.extScene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEUP, this._onMouseUp, this);
    }
    _unsubscribeEvents() {
        this.extScene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEMOVE, this.mousemoveeventnr);
        this.extScene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEUP, this.mouseupeventnr);
        this.extScene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.PANO_ROTATION, this.panoroteventnr);
        this.extScene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.PANO_ZOOM, this.panozoomeventnr);
    }
    initScene2d() {
        this.scene2d = new Canvas2dutilScene(0, 0, this.extScene.engine.getCanvas().width, this.extScene.engine.getCanvas().height, this.extScene.engine.getCanvas().parentElement);
        //create or update an observation indicator
        this.epipolarline = this.scene2d.createLine(0, 0, 3, {});
        this.updateEpipolarLines();
        this.scene2d.render();
    }
    addImageSelectionMenu() {
        const menu = document.createElement("div");
        Object.assign(menu.style, {
            position: "relative",
            bottom: "50px",
            width: "100%",
            textAlign: "center",
            pointerEvents: "none",
        });
        for (let i = 0; i < this.candidateGeoFrames.length; i++) {
            const div = document.createElement("div");
            div.id = this.getIdFromGeoFrame(this.candidateGeoFrames[i]);
            this.imageSelectionDivs.push(div);
            Object.assign(div.style, this.imageSelectorCSS);
            div.addEventListener("mouseover", (e) => {
                const target = e.target;
                if (target.id != this.activeGeoFrameId)
                    Object.assign(target.style, this.imageSelectorOnMouseOverCSS);
            });
            div.addEventListener("mouseout", (e) => {
                const target = e.target;
                if (target.id != this.activeGeoFrameId) {
                    Object.assign(target.style, this.imageSelectorCSS);
                }
            });
            div.addEventListener("mouseup", (e) => {
                const target = e.target;
                this._changeActiveGeoframe(target.id);
            });
            menu.appendChild(div);
        }
        this.externalSceneDomElement.appendChild(menu);
    }
    _changeActiveGeoframe(id) {
        const gf = this.getCandidateGeoFrameFromId(id);
        this.activeGeoFrameId = id;
        this.activeGeoFrame = gf;
        if (gf.parentGeoFrameCollection == this.extScene.getCurrentGeoFrameCollection()) {
            this.extScene.getCurrentGeoFrameCollection().searchToFramenumber(gf.getFramenumber());
        }
        else {
            this.extScene.setGeoFrames(gf, gf.parentGeoFrameCollection.geoframearray);
        }
        const qp = this.queryPointsByFrameId[id];
        if (this.imageObservation.streamtype == STREAMTYPE.CUBEMAP) {
            gf.zoomToCenterPoint([qp.x, qp.y, qp.z], 2, 100, 5, false, this.imageObservation.faceorientation);
        }
        else {
            gf.zoomToCenterPoint([qp.x, qp.y, qp.z], 2, 100, 5, false);
        }
        this.extScene.infrascene.render();
    }
    _updateImageSelection() {
        this.imageSelectionDivs.forEach((div) => {
            if (this.activeGeoFrameId == div.id) {
                Object.assign(div.style, this.imageSelectorActiveCSS);
            }
            else {
                Object.assign(div.style, this.imageSelectorCSS);
            }
        });
    }
    finish() {
        console.log("finish");
    }
    abort() {
        console.log("abort");
    }
    _onMouseMove() {
        this.scene2d.render();
    }
    _onMouseUp(evt) {
        if (evt.isDragging || evt.button > 0)
            return;
        //create a new image observation
        const mapinfo = this.extScene.getMeasureHandler().mouseToMap(evt.offsetX, evt.offsetY);
        const map = mapinfo[0].coords;
        const minfo = this.activeGeoFrame.getMeasureInfo();
        const senscoor = this.extScene.getMeasureHandler().mapToSensor(map);
        let ck;
        if (minfo.streamtype == STREAMTYPE.CALOTTE) {
            ck = minfo.sensors[mapinfo[0].sensorid].focallength;
        }
        else {
            // PROJECTION.PERSPECTIVE -> Stereo Case : images are normaliced to normfocallength in processing
            ck = minfo.imagemeta.focallength;
        }
        let io;
        if (minfo.streamtype == STREAMTYPE.CUBEMAP) {
            io = new ImageObservation(this.activeGeoFrame, senscoor.x, senscoor.y, ck, this.activeGeoFrameId, mapinfo[0].sensorid, mapinfo[0].cubefaceorientation, mapinfo[0].cubefaceindex);
        }
        else {
            io = new ImageObservation(this.activeGeoFrame, senscoor.x, senscoor.y, ck, this.activeGeoFrameId, mapinfo[0].sensorid);
        }
        this.successCbf(io);
    }
    geoframechanged() {
        this._updateImageSelection();
    }
    getIdFromGeoFrame(geoframe) {
        return geoframe.id;
    }
    getCandidateGeoFrameFromId(id) {
        for (let i = 0; i < this.candidateGeoFrames.length; i++) {
            const gfid = this.getIdFromGeoFrame(this.candidateGeoFrames[i]);
            if (gfid == id)
                return this.candidateGeoFrames[i];
        }
        return null;
    }
    /**
     * updates the epipolar line according to pan or zoom imagequadtree
     * @private
     */
    updateEpipolarLines() {
        const geoframecollection = this.activeGeoFrame.parentGeoFrameCollection;
        let sensorid = 0;
        let faceorientation;
        let faceindex = 0;
        if (geoframecollection.imagequadtree) {
            sensorid = geoframecollection.imagequadtree.faceindex;
            faceindex = sensorid;
            if (geoframecollection.type == STREAMTYPE.CUBEMAP) {
                sensorid = geoframecollection.currentsensor;
                faceindex = geoframecollection.imagequadtree.faceindex;
                faceorientation = geoframecollection.imagequadtree.faceToOrientation(faceindex);
            }
        }
        //update epipolar line offset changed by dragging or zooming
        let linepoints;
        if (geoframecollection.type == STREAMTYPE.CUBEMAP) {
            linepoints = this.imageObservation.getEpipolarLine(this.activeGeoFrame, sensorid, faceorientation);
        }
        else {
            linepoints = this.imageObservation.getEpipolarLine(this.activeGeoFrame, sensorid);
        }
        //const linepoints = this.imageObservation.getEpipolarLine(this.activeGeoFrame, sensorid);
        const map_p1 = this.extScene.getMeasureHandler().sensorToMap(linepoints[0]);
        const map_p2 = this.extScene.getMeasureHandler().sensorToMap(linepoints[1]);
        const mouse_p1 = this.extScene.getMeasureHandler().mapToMouse(map_p1.x, map_p1.y, faceindex);
        const mouse_p2 = this.extScene.getMeasureHandler().mapToMouse(map_p2.x, map_p2.y, faceindex);
        const m = (mouse_p1.y - mouse_p2.y) / (mouse_p1.x - mouse_p2.x);
        const q = mouse_p1.y - m * mouse_p1.x;
        //intersect line with y axis (x=0)
        mouse_p1.x = 0;
        mouse_p1.y = q;
        mouse_p2.x = this.extScene.engine.getContextWidth();
        mouse_p2.y = this.extScene.engine.getContextWidth() * m + q;
        this.epipolarline.p1 = mouse_p1;
        this.epipolarline.p2 = mouse_p2;
        this.scene2d.render();
    }
    destroy() {
        this._unsubscribeEvents();
        this.scene.destroySubScene(this.extScene);
        const infra3ddiv = this.scene.engine.getCanvas().parentElement;
        infra3ddiv.removeChild(this.externalSceneDomElement);
        this.extScene = null;
    }
}
//# sourceMappingURL=externalmeasurescene.js.map